var url = ''
if (window.location.host === 'arkan-qr.premiere-cinemas.com') {
  url = 'https://arkan-api.premiere-cinemas.com'
} else {
  url = 'https://arkan-api.premiere-cinemas.com'
}
export const URL_BASE = url



// WEBPACK FOOTER //
// ./src/helper/constants.js